var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20ZM30.1555 13.6593C31.1223 13.5445 32.0443 13.2875 32.9014 12.9074C32.2607 13.8661 31.4503 14.7078 30.5155 15.3817C30.5248 15.5863 30.5294 15.7927 30.5294 15.9999C30.5294 22.3177 25.7207 29.6021 16.9275 29.6021C14.228 29.6021 11.7145 28.811 9.6 27.4541C9.97328 27.4987 10.3548 27.5211 10.7398 27.5211C12.9802 27.5211 15.0412 26.7571 16.6776 25.4747C14.5852 25.4359 12.8201 24.0536 12.2119 22.1548C12.5035 22.2104 12.8026 22.24 13.1114 22.24C13.5467 22.24 13.9699 22.1819 14.3706 22.0721C12.184 21.6332 10.5355 19.7012 10.5355 17.3849C10.5355 17.365 10.5355 17.3447 10.5359 17.3243C11.1801 17.6833 11.9177 17.8983 12.701 17.9229C11.419 17.0659 10.5744 15.602 10.5744 13.9438C10.5744 13.0678 10.8104 12.2461 11.2218 11.5402C13.5798 14.4333 17.1026 16.3364 21.0756 16.5357C20.9936 16.1856 20.9512 15.8209 20.9512 15.4462C20.9512 12.8065 23.0921 10.6656 25.7318 10.6656C27.1076 10.6656 28.35 11.246 29.2221 12.1748C30.3105 11.9605 31.3341 11.563 32.2578 11.015C31.9003 12.132 31.1427 13.0678 30.1555 13.6593Z",
    fill: "#50ABF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c075848b50668533300970e134769c72.svg";
export { ForwardRef as ReactComponent };